import Image from 'next/image';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import useIsAndroid from '@alltrails/core/hooks/useIsAndroid';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Button from '@alltrails/denali/components/Button';
import Divider from '@alltrails/denali/components/Divider';
import Heading from '@alltrails/denali/components/Heading';
import StarRating from '@alltrails/denali/components/StarRating';
import PlusLogoBadge from '@alltrails/denali/components/SubscriptionBadge/Logo/Plus';
import AppleEditorsChoice from '@alltrails/install-prompt/components/AppleEditorsChoice';
import QRCode from '@alltrails/install-prompt/components/QRCode';
import AppStore from '@alltrails/layout/components/Footer/StoreBadges/AppStore';
import GooglePlay from '@alltrails/layout/components/Footer/StoreBadges/GooglePlay';
import styles from './AppDownloadAndReview.module.scss';
import lakeWithMountainsSrc from './lake-with-mountains-image.avif';
const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/alltrails-hike-bike-run/id405075943';
const ANDROID_APP_STORE_URL = 'https://play.google.com/store/apps/details?id=com.alltrails.alltrails';

const AppDownloadAndReview = () => {
  const languageRegionCode = useLanguageRegionCode();
  const intl = useIntl();
  const isAndroid = useIsAndroid();
  const appStoreUrl = isAndroid ? ANDROID_APP_STORE_URL : IOS_APP_STORE_URL;

  return (
    <div className={styles.container}>
      <div className={styles.appSectionContainer}>
        <div className={styles.appRatingContainer}>
          <AppleEditorsChoice height={40} width={158} />
          <div className={styles.rating}>
            <Typography variant="text200bold">
              <FormattedNumber value={4.9} />
            </Typography>
            <StarRating rating={5} size="sm" />
          </div>
        </div>
        <Heading as="h2" className={styles.header} size="600">
          <FormattedMessage defaultMessage="Find your outdoors" />
        </Heading>
        <Divider classes={styles.sectionDivider} />
        <div className={styles.downloadCodeContainer}>
          <QRCode size={165} />
          <span className={styles.storeBadgeContainer}>
            <AppStore height={61} intl={intl} languageRegionCode={languageRegionCode} className={styles.appStoreBadge} />
            <GooglePlay height={54} intl={intl} languageRegionCode={languageRegionCode} />
          </span>
        </div>
        <div className={styles.appDownloadButtonContainer}>
          <Button text={<FormattedMessage defaultMessage="Download the app" />} linkInfo={{ href: appStoreUrl }} variant="primary" size="md" />
        </div>
      </div>
      <div className={styles.testimonialSectionContainer}>
        <Image
          className={styles.bgImage}
          src={lakeWithMountainsSrc}
          alt={intl.formatMessage({ defaultMessage: 'Person swimming in a mountain lake.' })}
        />
        <div className={styles.dialogBoxContainer}>
          <Typography className={styles.reviewText} variant="paragraph200">
            <FormattedMessage defaultMessage="AllTrails Plus has been a literal time and lifesaver for me. AllTrails Plus allows you to download trail maps before you start hiking so you can access the map for the entire trail." />
          </Typography>
          <div className={styles.reviewerContainer}>
            <PlusLogoBadge size="sm" variant="icon" />

            <Typography variant="paragraph200" className={styles.reviewer}>
              Julia K
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadAndReview;
